import { useState } from "react";
import { observer } from "mobx-react";
import { CloseSquare, Trash } from "iconsax-react";
import { Box, Dialog, DialogContent, DialogTitle, DialogActions, IconButton, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import RoundButton from "../../content/shared/components/round-btn";
import styles from '../my-data.module.scss';

const DeleteSectionModal = observer(({ sections, uiStore, feedback, onDeleteCategory, category, updateData, btnStyle = 'fullBtn' }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const confirm = async () => {
        setLoading(true);
        await uiStore.deleteAllSections(sections?.name);
        const data = await uiStore.fetchCategoryInfo(category.name, true);
        updateData(data);
        onDeleteCategory(category.name);
        setLoading(false);
        if (feedback)
            feedback();
        setShow(false);
    }

    return (
        <Box sx={{ textAlign: 'center' }}>

            {btnStyle === 'fullBtn' &&
                <RoundButton
                    variant="contained"
                    onClick={() => setShow(true)}
                    color="lightblue"
                    className={`${styles.mydataEditBtn} ${styles.hideInMobile}`}
                    sx={{ ml: 1 }}
                >
                    <Trash
                        size="24"
                        variant="Bulk"
                    />
                    <Box className={styles.hideText}>Delete</Box>
                </RoundButton>
            }

            {btnStyle === 'iconOnly' &&
                <IconButton
                    onClick={() => setShow(true)}
                    sx={{ ml: 1 }}
                >
                    <Trash
                        size="24"
                        variant="Bulk"
                    />
                </IconButton>
            }

            <Dialog open={show} onClose={() => setShow(false)}
                PaperProps={{ sx: { padding: '20px' }, variant: 'round' }}
            >
                <DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={() => setShow(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseSquare
                            size="30"
                            variant="Bulk"
                        />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ textAlign: 'center' }}>
                    <Box className={styles.deleteIconContainer}>
                        <Trash
                            size="30"
                            variant="Bulk"
                        />
                    </Box>
                    <Typography fontWeight={600}>Delete {sections?.name} section</Typography>
                    <Typography color='#888888'>Are you sure you want to
                        delete {sections?.name} sections?</Typography>

                </DialogContent>
                <DialogActions>
                    <LoadingButton loading={!!loading} onClick={() => setShow(false)} variant="contained"
                        color="lightblue">
                        Cancel
                    </LoadingButton>
                    <LoadingButton loading={!!loading} onClick={confirm} variant="contained" color="error">
                        Delete
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </Box>
    );
});

export default DeleteSectionModal;
